import Vue from 'vue'
import VPageTip  from './pageTip'

export default VPageTip




// WEBPACK FOOTER //
// ./src/components/pageTip/index.js